import { AppIcon } from '../../../../theme';
import { search } from '../../../../theme/icons';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { ClearButton } from 'react-bootstrap-typeahead';
import t from '../../../../localization/en/translation.json';
import { useDispatch, useSelector } from 'react-redux';
import { APP_STATE } from '../../../../store/reducers';
import DOMPurify from 'dompurify';
import { getStringWithBold } from '../../../../utils/helper-utility';
import './listUserEmailDropdown.scss';
import { forwardRef, useEffect, useState } from 'react';
import { searchUsersAction } from '../../../../store/actions/user-actions';
import {
  createUserObject,
  handleEmailValidation,
  updateAddNewUser,
} from '../../../../utils/manageUserHelpers';
import { getProjectUsersListSuccess } from '../../../../store/actions/project-actions';
import { addNewUserSelected, setColumnExpand } from '../../../../store/actions/manage-user-actions';
import { getValidEmailDomain } from '../../../../store/apis/projectApi';

interface IOption {
  givenName: string;
  surname: string;
  mail: string;
  officeLocation?: string | null;
}

const initialEmailError = {
  inValid: false,
  message: '',
};

export const ListUserEmailDropdown = forwardRef(({ props }: any, ref) => {
  const [searchQuery, setSearchQuery] = useState('');
  // const [searchInputText, setSearchInputText] = useState('');
  const [isEmailError, setIsEmailError] = useState(initialEmailError);
  const dispatch = useDispatch();
  const { searchUsersLoader, searchUsersData } = useSelector(
    (state: APP_STATE) => state.searchUsersReducer
  );
  const { record, users, userGridPagination } = useSelector(
    (state: APP_STATE) => state.projects
  );
  const manageUserData = useSelector(
    (state: APP_STATE) => state.manageUserReducer
  );
  const platformRoles = useSelector((state: APP_STATE) => state.meta.userRoles);

  useEffect(() => {
    if (!searchUsersLoader && searchQuery?.length > 3 && !searchUsersData.length) {
      const { inValid, message } = handleEmailValidation(searchQuery);
      if (!inValid) {
        checkEmailDomain(record.id, searchQuery);
      } else {
        setIsEmailError({
          inValid: inValid,
          message: message,
        });
      }
    } else {
      setIsEmailError(initialEmailError);
    }
    // eslint-disable-next-line no-autofix/react-hooks/exhaustive-deps
  }, [searchUsersData, searchUsersLoader]);

  const renderMenuItem = (option, props) => {
    const stringData = option.displayName + ', ' + option.mail;
    return (
      <div
        className="async-dropdown"
        title={stringData}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(getStringWithBold(stringData, props.text)),
        }}
      ></div>
    );
  };

  const handleSearchKeyDown = (event) => {
    if (event.keyCode === 220 || event.keyCode === 219) {
        event.preventDefault(); // Prevent the default action (typing the backslash)
    }
  }

  const handleSearchChange = (query) => {
    const searchValue = {
      pageSize: 51,
      pageNumber: 1,
      sortColumn: 'displayName',
      skipToken: null,
      filters: [
        {
          filterText: query,
        },
      ],
    };
    setSearchQuery(query);
    dispatch(searchUsersAction(searchValue, true, record.id));
  };

  const handleSelectValue = (selectedArray, rowId, isExternalUser = false) => {
    if (!selectedArray?.length) {
      setIsEmailError(initialEmailError);
      return;
    }
    const isDuplicateUser = users.some(
      (v) => v.mail === selectedArray[0]?.mail
    );
    if (isDuplicateUser) {
      setIsEmailError({
        inValid: true,
        message: t.manage_user_duplicate,
      });
    } else {
      const updatedUserList = updateAddNewUser(
        users,
        selectedArray,
        rowId,
        isExternalUser,
        platformRoles
      );
      dispatch(
        getProjectUsersListSuccess({
          data: {
            records: updatedUserList,
            pagination: userGridPagination,
          },
        })
      );
      const updatedData = createUserObject(selectedArray[0], platformRoles);
      dispatch(
        addNewUserSelected([...manageUserData.addNewUserSelected, updatedData])
      );
    }
  };

  const checkEmailDomain = (projectId, emailId) => {
    getValidEmailDomain(projectId, emailId).then((res) => {
      setIsEmailError({
        inValid: !res?.isAllowed,
        message: t.manage_user_domain_fail,
      });
      if (res?.isAllowed) {
        if(res?.isInternal) {
          setIsEmailError({
            inValid: true,
            message: t.manage_user_email_not_found,
          });
          return;
        }
        const updatedData = {
          ...props.data,
          mail: emailId,
          userEmail: emailId,
          isAllowedDomain: true,
          userDetails: { ...props.data.userDetails, mail: emailId },
        };
        dispatch(setColumnExpand(true));
        handleSelectValue([updatedData], props.data.id, true);
      }
    });
  };

  return (
    <>
      <div
        id={`custom-cell-${props.data.id || props.data.key}-${
          props.colDef?.field
        }`}
        className={`grid-cell-search-wrapper ${
          isEmailError.inValid ? 'error' : ''
        }`}
      >
        <AppIcon icon={search} />
        <AsyncTypeahead
          id="async-search"
          isLoading={searchUsersLoader}
          filterBy={() => true}
          labelKey={(option: IOption) => `${option.mail}`}
          minLength={3}
          onSearch={handleSearchChange}
          options={searchUsersData || []}
          onChange={(selected) => handleSelectValue(selected, props.data.id)}
          placeholder={t.manage_user_search_user}
          renderMenuItemChildren={(option, props) =>
            renderMenuItem(option, props)
          }
          emptyLabel={t.manage_user_email_no_match}
          delay={300}
          useCache={false}
          onKeyDown={handleSearchKeyDown}
        >
          {({ onClear }) => (
            <div className="rbt-aux">
              {/* {searchInputText?.length > 0 && ( */}
                <ClearButton
                  onClick={() => {
                    setIsEmailError(initialEmailError);
                    onClear();
                  }}
                />
              {/* )} */}
            </div>
          )}
        </AsyncTypeahead>
        {isEmailError.inValid && (
          <div className="error-tooltip">
            <p>{isEmailError.message}</p>
          </div>
        )}
      </div>
    </>
  );
});

export default ListUserEmailDropdown;
